/**
 * Parse currency values with M/K suffixes to numeric values
 * @param value - Currency string like "5.2M", "150K", or "N/A"
 * @returns Numeric value in millions (e.g., "5.2M" returns 5.2, "150K" returns 0.15)
 */
export const parseNumericValue = (value: string): number => {
  if (value === "N/A") return 0;

  const match = /([\d.]+)([MK]?)/.exec(value);
  if (!match) return 0;

  const num = parseFloat(match[1]);
  const unit = match[2];

  // Convert to millions: M = millions, K = thousands, no unit = assume raw value in currency units
  return unit === "M" ? num : unit === "K" ? num / 1000 : num / 1000000;
};
